import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import LightModeIcon from '@mui/icons-material/LightMode';
import Badge from '@mui/material/Badge';
import { DarkModeContext } from '../../context/darkModeContext';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, collection, onSnapshot, updateDoc, where, query } from 'firebase/firestore';
import { db } from '../../firebase';
import { UserAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

function Navbar() {
  const { darkMode, dispatch } = useContext(DarkModeContext);
  const { userId } = useParams();
  const [userData, setUserData] = useState([]);
  const [amount, setAmount] = useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const { logout } = UserAuth();

  const settings = [
    { title: 'Profile', link: 'profile' },
    { title: 'Edit Profile', link: 'update' },
    { title: 'Dashboard', link: 'dashboard' },
  ];

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  useEffect(() => {
    const q = query(collection(db, 'users', userId, 'notifications'), where('isCheck', '==', false));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notifi = [];
      querySnapshot.forEach((doc) => {
        notifi.push(doc.data());
      });
      setAmount(notifi.length);
    });

    return () => {
      unsubscribe();
    };
  }, [userId]);

  useEffect(() => {
    userId && getSingleUser();
    // eslint-disable-next-line
  }, []);

  const getSingleUser = async () => {
    const docRef = doc(db, 'users', userId);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      setUserData({ ...snapshot.data() });
    }
  };

  const handleLogout = async () => {
    try {
      const status = doc(db, 'users', userId);
      await updateDoc(status, {
        status: false,
      });
      await logout();
      navigate('/');
      console.log('You are logged out');
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <NavbarStyled className="navbar">
      <div className="wrapper">
        <div className="search"></div>
        <div className="items">
          <div className="item">
            {darkMode ? (
              <Tooltip title="Light Mode">
                <LightModeIcon className="icon" onClick={() => dispatch({ type: 'TOGGLE' })} />
              </Tooltip>
            ) : (
              <Tooltip title="Dark Mode">
                <DarkModeOutlinedIcon className="icon" onClick={() => dispatch({ type: 'TOGGLE' })} />
              </Tooltip>
            )}
          </div>

          <Link to={`/${userId}/notifications`}>
            <div className="item">
              <Tooltip title="Notifications">
                <Badge badgeContent={amount} color="success">
                  <NotificationsNoneIcon color="action" className="icon" />
                </Badge>
              </Tooltip>
            </div>
          </Link>

          <div className="item">
            <Tooltip title="Profile">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="" src={userData.img} sx={{ width: 32, height: 32 }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting, index) => (
                <Link to={`/${userId}/${setting.link}`} key={index}>
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography textAlign="center">{setting.title}</Typography>
                  </MenuItem>
                </Link>
              ))}
              <MenuItem onClick={handleLogout}>
                <Typography textAlign="center">Logout</Typography>
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </NavbarStyled>
  );
}

const NavbarStyled = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 14px;

  .wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    input {
      border: none;
      outline: none;
      background: transparent;
      &::placeholder {
        font-size: 12px;
      }
    }
  }

  .items {
    display: flex;
    align-items: center;
    cursor: pointer;

    .item {
      display: flex;
      align-items: center;
      margin: 15px;
      position: relative;
      @media screen and (max-width: 956px) {
        margin: 10px;
      }
      .icon {
        color: #fff;
        font-size: 25px;
      }

      .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
    }
  }
`;

export default Navbar;
